import { render, staticRenderFns } from "./EditGenre.vue?vue&type=template&id=28ea40bf&scoped=true&"
import script from "./EditGenre.vue?vue&type=script&lang=js&"
export * from "./EditGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea40bf",
  null
  
)

export default component.exports